<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {
    
  }
}
</script>

<style>
*{
  margin: 0;
  padding:0
}
html,body,#app{
  height: 100%;
  box-sizing: border-box;
  margin: 0;
}
</style>
